import { formatBUList } from "./FormatBuList";
import { markRecursive } from "./MarkRecursive";

import { TreeDataValue } from "@/core/libs/tree-select-dropdown/TreeSelectDropdown";
import { BusinessUnit, BusinessUnitRegion } from "@/modules/User/types/types";

export const selectedNodesToTree = (
  businessUnits: TreeDataValue[],
  userBusinessUnits?: BusinessUnit[],
  userBusinessUnitClassification?: BusinessUnitRegion[]
): TreeDataValue[] => {
  const selectedBuId = businessUnits?.map(businessUnit => businessUnit.value);
  const buList = formatBUList(
    userBusinessUnits,
    userBusinessUnitClassification
  );

  return markRecursive(buList, selectedBuId);
};
